import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    hidden: true,
    redirect: {
      path: '/home',
    },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home.vue'),
        meta: {
          title: 'ACEY- 苏州艾盛 - 首页',
        },
      },
      {
        path: '/Sass_platforms',
        name: 'SaasPlatforms',
        component: () => import('@/views/saas_platforms.vue'),
        meta: {
          title: 'ACEY- 苏州艾盛 - SaaS Platforms',
        },
      },
    ],
  },
]

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

// 路由变化跳转页面回到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
